import React, {useState, useEffect} from 'react';
import {useParams, useHistory} from 'react-router-dom';
import {API} from 'aws-amplify';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Unstable_Grid2';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import {faPlay} from '@fortawesome/pro-solid-svg-icons';

import PrimaryAppBar from './PrimaryAppBar';
import SecondaryAppBar from './SecondayAppBar';
import ShareDialog from './ShareDialog';

import baseStyles from '../../css/Base.module.css';
import {ENDPOINT} from '../../constants';

export default function Session() {
  const history = useHistory();
  const {sessionID} = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [isShareDialogOpen, toggleShareDialog] = useState(false);
  const [shareURL, setShareURL] = useState('');

  const [students, setStudents] = useState([1, 2, 3, 4, 5]);

  useEffect(() => {
    if (sessionID) {
      const fetchAssignments = async () => {
        const assignments = await API.get(ENDPOINT, `/assignments?sessionID=${sessionID}`);
        const students = assignments.map((assignment) => assignment.student);
        const uniqueStudentIDs = Array.from(new Set(students.map((student) => student.id)));
        const uniqueStudents = uniqueStudentIDs.map((studentID) =>
          students.find((student) => student.id === studentID),
        );
        setStudents(uniqueStudents);
        setIsLoading(false);
      };
      fetchAssignments();
    }
  }, [sessionID]);

  function handleClickGetShareLink(student) {
    const shareURL = `${window.location.origin}/student/dashboard?authCode=${student.authCode}`;
    setShareURL(shareURL);
    toggleShareDialog(true);
  }

  function renderStudent(student) {
    return (
      <Paper key={student.id} sx={{padding: 2}} className="m-t-20">
        <List>
          <ListItem
            secondaryAction={
              <Button variant="text" onClick={() => handleClickGetShareLink(student)}>
                GET LINK
              </Button>
            }
          >
            <ListItemText
              primary={`${student.firstName} ${student.lastName}`}
              primaryTypographyProps={{variant: 'h5', className: 'fnt-bold'}}
            />
          </ListItem>
        </List>
        <Divider />
        <Typography variant="h1" className="m-l-30">{`${student.authCode.substring(0, 3)} ${student.authCode.substring(
          3,
          6,
        )}`}</Typography>
      </Paper>
    );
  }

  return (
    <>
      <PrimaryAppBar />
      <SecondaryAppBar title="Make Assignments">
        <IconButton
          onClick={() =>
            history.push(`/assignment?authCode=${students?.[0]?.authCode}&sessionID=${sessionID}&auto=true`)
          }
          className="bg-success"
          size="large"
          sx={{'&:hover': {backgroundColor: 'rgba(66, 184, 94, 0.8)'}}}
        >
          <FontAwesomeIcon icon={faPlay} size="xs" className="clr-gray-200" />
        </IconButton>
      </SecondaryAppBar>
      <ShareDialog open={isShareDialogOpen} handleClose={() => toggleShareDialog(false)} shareURL={shareURL} />

      <div className="p-20">
        <Typography variant="subtitle1" className="clr-dark-blue fnt-bold">
          Starting a session...
        </Typography>
        <Typography>
          Have each student open a browser and navigate to: {window.location.origin}
        </Typography>
        <Typography>
          Instruct them to click the &quot;HAVE A JOIN CODE&quot; button at the top left, and enter the code
          corresponding to their name below. Alternatively, you can generate a link for each student.
        </Typography>
        <Typography>
          When you&apos;re ready to model your session, click the green play button in the top right.
        </Typography>

        {isLoading && (
          <div className={baseStyles['progress-container']}>
            <CircularProgress />
          </div>
        )}

        {!isLoading && students.length > 0 && (
          <Grid container spacing={2}>
            <Grid xs={12}>{students.map(renderStudent)}</Grid>
          </Grid>
        )}
      </div>
    </>
  );
}
